import * as yup from 'yup'
import { pt } from 'yup-locale-pt'

yup.setLocale(pt)

export const validationSchema = (name = 'email') =>
  yup.object().shape({
    [name]: yup.string().email().nullable().required().label('E-mail'),
    current_password: yup.string().nullable().required().label('Senha atual')
  })
